var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"svgbox"},[_c('oss-img',{attrs:{"width":200,"height":200,"src":"https://img.kakaclo.com/web-img/home/empty_search.png"}})],1),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_vm._v(" "+_vm._s(_vm.$t('productList.canFind'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }